export default __webpack_public_path__ + "static/media/bot1.50d71e99.jpg";